module.exports = __webpack_public_path__ + "43e688eaee111aae906cce27f2f70c04.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/Rist/content/tourWorks/room5/audio1/05_MCA Pixelworld.mp3
// module id = 784
// module chunks = 0